@if (visibleLegends.length > 0) {
  <div class="scalar-legend-container">
    @for (legend of visibleLegends; track legend.title) {
      <div class="legend-card">
        <div class="legend-title">{{ legend.title }}</div>
        @for (entry of legend.entries; track entry.label) {
          <div class="legend-entry">
            <span class="legend-swatch" [style.background-color]="entry.color"></span>
            <span class="legend-label">{{ entry.label }}</span>
          </div>
        }
      </div>
    }
  </div>
}
